export default "/images/vendor/flag-icon-css/flags/1x1/pt.svg?5697f2973616282e4c76ffeadbc78f0a";